import { withCoursePriceStore } from '../course-price-store/with-course-price-store';
import { StaticPriceText } from './static-price-text.react-component';
export const AsyncCourseStaticPriceText = withCoursePriceStore(StaticPriceText);
//# sourceMappingURL=async-course-static-price-text.react-component.js.map